import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md-3" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_ConsulteGrid = _resolveComponent("ConsulteGrid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ErrorMessage, { name: "bibTipoDocumento" })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ConsulteGrid, {
        columns: _ctx.rows,
        "data-source": _ctx.dataSource,
        actions: true,
        onOnChangeDataRow: _ctx.rowChange
      }, {
        botaoExemplar: _withCtx((context) => [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-warning",
            onClick: ($event: any) => (_ctx.exemplar(context.row))
          }, " Exemplar ", 8, _hoisted_3)
        ]),
        _: 1
      }, 8, ["columns", "data-source", "onOnChangeDataRow"])
    ])
  ], 64))
}